import { render, staticRenderFns } from "./ModalAddAmendment.vue?vue&type=template&id=9a164408&"
import script from "./ModalAddAmendment.vue?vue&type=script&lang=js&"
export * from "./ModalAddAmendment.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddAmendment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports